"use client";

import type { ServerPanelConfiguratorProps } from "~/components/configurator/utilities";
import { useMedia } from "~/components/media/Provider";
import { BasePanelConfigurator, type BasePanelConfiguratorProps } from "./BasePanelConfigurator";

type Props = ServerPanelConfiguratorProps & BasePanelConfiguratorProps;

export function PdpPanelConfigurator(props: Props) {
	const { setPanelData } = useMedia();

	return (
		<BasePanelConfigurator {...props} variant="pdp" onDataChange={(data) => setPanelData(data)} />
	);
}
